import React, { useEffect } from "react";
import { Row, Col, Form, Modal, Descriptions, notification } from "antd";
import { SaveOutlined, CloseOutlined } from "@ant-design/icons";

import api from "../../../services/api";
import InputPreco from "../../inputPreco";
import InputQuantidade from "../../inputQuantidade";
import { FormatNumber } from "../../../ValueObjects";
import Data from "../../data";

export default function ModalItemInventario({ form, dadosItem, exibirModal, onCloseModal, TipoCodigoProduto }) {

    const [formulario] = Form.useForm();

    useEffect(() => {
        if (dadosItem) {
            formulario.setFieldsValue({
                ivi_dataposicao: dadosItem.ivi_dataposicao,
                ivi_estoqueatual: dadosItem.ivi_estoqueatual,
                ivi_customedio: dadosItem.ivi_customedio,
                ivi_custoultimacompra: dadosItem.ivi_custoultimacompra,
                ivi_custosemicms: dadosItem.ivi_custosemicms,
                ivi_custocomicms: dadosItem.ivi_custocomicms,
            })
        }
        setarCampoQtde();
    }, [dadosItem]);

    function setarCampoQtde() {
        setTimeout(() => {
            try {
                let element = document.getElementById("qtdeEstoque");
                if (element) {
                    element.focus();
                    element.select(); // Seleciona todo o texto dentro do campo
                }
            } catch (error) {
                console.log('error :>> ', error);
            }
        }, 200);
    }


    const alterarItem = record => {
        let dados = {};
        dados.TipoCodigoProduto = TipoCodigoProduto;
        dados.inv_id = form.getFieldValue().inv_id;
        dados.ivi_id = dadosItem.ivi_id;
        dados.qtde = record.ivi_estoqueatual - dadosItem.ivi_estoqueatual;
        dados.ivi_dataposicao = formulario.getFieldValue().ivi_dataposicao;
        dados.ivi_customedio = formulario.getFieldValue().ivi_customedio;
        dados.ivi_custoultimacompra = formulario.getFieldValue().ivi_custoultimacompra;
        dados.ivi_custosemicms = formulario.getFieldValue().ivi_custosemicms;
        dados.ivi_custocomicms = formulario.getFieldValue().ivi_custocomicms;
        api.put(`Inventario/ModificarItem`, dados).then(
            res => {
                notification.success({ description: 'Item do inventário modificado com sucesso!', message: 'Aviso' });
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        ).finally(
            () => {
                formulario.resetFields();
                onCloseModal();
            }
        )
    };

    return (
        <Modal
            centered
            title="Manutenção de Item do Inventário"
            open={exibirModal}
            width={900}
            onCancel={() => {
                formulario.resetFields();
                onCloseModal();
            }}
            onOk={() => formulario.submit()}
            okText={
                <>
                    <SaveOutlined /> Salvar
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
        >
            <Row>
                <Col>
                    <Descriptions size="small">
                        <Descriptions.Item label="Produto">
                            <b>{dadosItem.pro_codigo} - {dadosItem.pro_descricao}</b>
                        </Descriptions.Item>
                    </Descriptions>
                </Col>
            </Row>
            {!!dadosItem.grade &&
                <Row>
                    <Col>
                        <Descriptions size="small">
                            <Descriptions.Item label="Grade">
                                <b>{dadosItem.grade}</b>
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
            }
            <Row>
                <Col span={24}>
                    <Descriptions size="small">
                        <Descriptions.Item label="Quantidade do estoque anterior">
                            <b>{FormatNumber(dadosItem.ivi_estoqueanterior, true)} {dadosItem.ump_id}</b>
                        </Descriptions.Item>
                    </Descriptions>
                </Col>
            </Row>
            <Row className="m-t-8">
                <Form layout="vertical" form={formulario} name="formItemInventario" onFinish={alterarItem}>
                    <Row gutter={16}>
                        <Col xs={24} sm={12} md={4} lg={4} xl={4} xxl={4}>
                            <Data label="Data Posição" name="ivi_dataposicao" />
                        </Col>
                        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                            <InputQuantidade name="ivi_estoqueatual" label="Qtde Estoque" precision={dadosItem.ump_casasdecimais} id="qtdeEstoque" />
                        </Col>
                        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                            <InputPreco label="Custo Médio (R$)" name="ivi_customedio" />
                        </Col>
                        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                            <InputPreco label="Custo Atual (R$)" name="ivi_custoultimacompra" />
                        </Col>
                        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                            <InputPreco label="Custo Sem ICMS (R$)" name="ivi_custosemicms" />
                        </Col>
                        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                            <InputPreco label="Custo Com ICMS (R$)" name="ivi_custocomicms" />
                        </Col>
                    </Row>
                </Form>
            </Row>
        </Modal >
    );
};
